import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

const home = () => import ('@/pages/home');
const details = () => import ('@/pages/details');
const catalog = () => import ('@/pages/catalog');
const catalogDetail = () => import ('@/pages/catalogDetail');

Vue.use(Router)

let router=  new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      redirect:'home'
    },
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },
    {
      path: '/catalog',
      name: 'catalog',
      component: catalog
    },
    {
      path: '/catalogDetail',
      name: 'catalogDetail',
      component: catalogDetail
    },
  ]
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};


let routerGo = function (path, params, isquery){
  if(isquery){
    router.push({path:path,query:params?params:{}})  //$routerGo('/index',{}，true)  url、带参数
  }else{
    router.push({name:path,params:params?params:{}})  //$routerGo('/index',{})  url不带参数
  }
};

export {
  router,
  routerGo
}




// WEBPACK FOOTER //
// ./src/router/index.js